// Reactive viewport flags via matchMedia — track rotation and resize, unlike
// the user-agent sniff they replace (the vsm_board / VSM Upcoming approach).
// mobileView (<=640px) drives the phone chrome; cardView (<900px) swaps the
// table for the card list earlier, where wide VSM tables stop being readable.
export default {
  data() {
    return {
      mobileView: false,
      cardView: false,
    }
  },

  mounted() {
    if (typeof window === 'undefined' || !window.matchMedia)
      return
    this._vsmQueries = []
    const bind = (query, apply) => {
      const mq = window.matchMedia(query)
      apply(mq.matches)
      const onChange = e => apply(e.matches)
      if (mq.addEventListener)
        mq.addEventListener('change', onChange)
      else
        mq.addListener(onChange)
      this._vsmQueries.push({ mq, onChange })
    }
    bind('(max-width: 640px)', matches => { this.mobileView = matches })
    bind('(max-width: 899px)', matches => { this.cardView = matches })
  },

  beforeDestroy() {
    for (const { mq, onChange } of this._vsmQueries || []) {
      if (mq.removeEventListener)
        mq.removeEventListener('change', onChange)
      else
        mq.removeListener(onChange)
    }
    this._vsmQueries = null
  },
}
